import { render, staticRenderFns } from "./Mouchards.vue?vue&type=template&id=76c5c3a9&"
import script from "./Mouchards.vue?vue&type=script&lang=js&"
export * from "./Mouchards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports